import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import UtmCapture from "@/components/UtmCapture";
import ContactSupport from "@/components/ContactSupport";
import { UserLocaleSync } from "@/components/UserLocaleSync";
import { AssistantProvider } from "@/contexts/AssistantContext";
import { CampaignEntryProvider } from '@/contexts/CampaignEntryProvider';
import { RouteMetadata } from '@/components/RouteMetadata';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <CampaignEntryProvider>
      <TooltipProvider>
        <AssistantProvider>
          <Toaster />
          <Sonner />
          <UtmCapture />
          <UserLocaleSync />
          <RouteMetadata />
          <ContactSupport />
          <Outlet />
        </AssistantProvider>
      </TooltipProvider>
      </CampaignEntryProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
